import Vue from "vue"

/***** SENTRY *****/
import * as Sentry from "@sentry/browser"
import { Vue as VueIntegration } from "@sentry/integrations"
import { Integrations } from "@sentry/tracing"

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
      tracingOptions: {
        trackComponents: true
      }
    }),
    new Integrations.BrowserTracing()
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0
})

import router from "./router"
import store from "./store"
import "@/permission"

// Vendors
import "normalize.css/normalize.css"
import "overlayscrollbars"
import "overlayscrollbars/css/OverlayScrollbars.min.css"

import lang from "element-ui/lib/locale/lang/fr"
import locale from "element-ui/lib/locale"

// configure language
locale.use(lang)

// importing global components
import "@/components/globals"

import "@/styles/index.scss"
import App from "./App.vue"
import "vue-tree-halower/dist/halower-tree.min.css" // you can customize the style of the tree
import { VTree, VSelectTree } from "vue-tree-halower"
import VueStripeCheckout from "vue-stripe-checkout"

// base/global options
// these options can be overridden
// by the options in the .open(options)
// function.
Vue.use(VueStripeCheckout, "pk_test_Z4YPRc2z0me4j5tzwoMVhvnS")
Vue.use(VTree)
Vue.use(VSelectTree)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
